/** @jsxRuntime classic */
/** @jsx jsx */
import { Text } from '@bottlebooks/gatsby-design-system/src';
import useAuthentication from '@bottlebooks/gatsby-plugin-firebase-auth/src/useAuthentication';
import {
  Button,
  Dialog,
  Flex,
  Link,
  P,
  SemiTitle,
} from '@bottlebooks/gatsby-theme-base/src';
import { Trans } from '@lingui/macro';
import '@reach/dialog/styles.css';
import { XCircle } from 'phosphor-react';
import { jsx } from 'theme-ui';

export default function RequestMeetingButtonBlocked({
  onDismiss,
}: {
  onDismiss: () => void;
}) {
  const { signIn, signOut } = useAuthentication();
  return (
    <Dialog style={{ maxWidth: 400 }}>
      <Dialog.Header onDismiss={onDismiss} />
      <Dialog.Content>
        <Flex
          direction="column"
          gap={3}
          align="center"
          sx={{ textAlign: 'center' }}
        >
          <XCircle
            size={50}
            weight="light"
            sx={{ marginTop: 0.5, color: 'brand.warningRed' }}
          />
          <SemiTitle>
            <Trans>Email address not registered for meeting booking</Trans>
          </SemiTitle>

          <Text>
            <Trans>
              The email you logged in with is not approved for meeting booking.
            </Trans>
          </Text>
          <Text>
            <Trans>
              Log in with another email or contact the organizer for assistance.
            </Trans>
          </Text>

          <Button
            variant="primary"
            onClick={() => {
              signOut();
              signIn();
              onDismiss();
            }}
            sx={{ marginTop: 3 }}
          >
            <Trans>Login with other email</Trans>
          </Button>
          <Link href="mailto:support@bottlebooks.me">
            <Text>
              <Trans>Contact support</Trans>
            </Text>
          </Link>
        </Flex>
      </Dialog.Content>
    </Dialog>
  );
}
